var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-fade-transition',[(_vm.loading)?_c('v-overlay',{attrs:{"color":_vm.backColor,"absolute":""}},[_c('v-progress-circular',{attrs:{"size":_vm.size,"color":_vm.color,"indeterminate":""}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }